const doc = [({"en":({"adminConstantChargeType":({"perPerson":"Per Person", "perRoom":"Per Room"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;